import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/document-templates`, formData);
  },
  async findOne({id}) {
    return axios.get(`/document-templates/${id}`);
  },
  async findAll() {
    return axios.get(`/document-templates`);
  },
  async delete({ id }) {
    return axios.delete(`/document-templates/${id}`);
  },
  async update({ id, formData }) {
    return axios.put(`/document-templates/${id}`, formData);
  }
};
